import type { Point } from 'geojson';

/**
 * Represents a location.
 */
export interface Location {

  /** geographic coordinates. */
  geometry: Point | null;

  /** address information. */
  address: {

    /** house number. */
    road_number: string | null;

    /** road or street name. */
    road: string | null;

    /** city name. */
    city: string | null;

    /** state name. */
    state: string | null;

    /** postal code. */
    zip: string | null;

    /** county name. */
    county: string | null;

    /** country name. */
    country: string | null;

    /** IANA country code. */
    country_code: string | null;
  } | null;
}

export class LocationHelpers {

  /**
   * Determines if instance has a valid geometry.
   * @param loc - location to check.
   */
  public static HasGeometry(loc: Location | null): boolean {
    if (loc?.geometry?.coordinates.length !== 2) {
      return false;
    }

    if (
      loc.geometry.coordinates[0] === 0 &&
      loc.geometry.coordinates[1] === 0
    ) {
      return false;
    }

    return true;
  }

  /**
   * Determines if instance has a valid address.
   * @param loc - location to check.
   */
  public static HasAddress(loc: Location | null): boolean {
    return Boolean(loc?.address?.country_code);
  }

  public static SingleLineAddress(loc: Location | null): string {
    if (!loc?.address?.country_code) {
      return '';
    }

    return `${loc.address.road_number ?? ''} ${loc.address.road} ${
      loc.address.city ?? loc.address.county
    } ${loc.address.state} ${loc.address.zip}`;
  }

  /**
   * Determines if instance represents a valid location.
   * @param loc - location to check.
   */
  private static HasLocation(loc: Location | null): boolean {
    return LocationHelpers.HasGeometry(loc);
  }

}
